import { render, staticRenderFns } from "./ui-icon.vue?vue&type=template&id=47ce4b0b&"
import script from "./ui-icon.vue?vue&type=script&lang=js&"
export * from "./ui-icon.vue?vue&type=script&lang=js&"
import style0 from "./_ui-icon.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports